let variantOptions = document.querySelectorAll(
  ".product-quick-view .variants-option input"
);
/////////////////////updating variant images
function updateVariantImage(variant, variantBlock) {
  let media = variantBlock
    .closest(".product-quick-view-wrap")
    .querySelectorAll(".product-media-container");
  media.forEach((el, ind) => {
    let variantOpt = el.querySelector("img").getAttribute("alt");
    if (variantOpt == variant.toLowerCase()) {
      scroll(el, null, ind);
    }
  });
}
variantOptions.forEach((el, ind) => {
  el.addEventListener("change", function () {
    if (el.checked) {
      let value = el.value.toLowerCase();
      updateVariantImage(value);
    }
  });
});
document.addEventListener("click", function (e) {
  if (
    e.target.classList.contains("quick-variant-selector") ||
    e.target.closest(".quick-variant-selector")
  ) {
    let el = e.target.classList.contains("quick-variant-selector")
      ? e.target
      : e.target.closest(".quick-variant-selector");
    let variantBlock = el;
    let inputs = el.querySelectorAll("input");
    updateVaraintForm(variantBlock);
    inputs.forEach(function (el, ind) {
      if (el.checked) {
        let value = el.value.toLowerCase();
        updateVariantImage(value, variantBlock);
      }
    });
  }
});
function updateVaraintForm(element) {
  let allOptions = element.querySelectorAll('input[type="radio"]');
  let variantsData = JSON.parse(
    element
      .closest(".product-quick-view-info")
      .querySelector(
        'form[action="/cart/add"] script[type="application/ld+json"]'
      ).textContent
  );
  let formInput = element
    .closest(".product-quick-view-info")
    .querySelector('form[action="/cart/add"] input[name="id"]');
  let ajaxButton = element
    .closest(".product-quick-view-info")
    .querySelector('form[action="/cart/add"] .ajax-cart');
  console.log(variantsData);
  let selectedOptions = [];
  let selectedOptionData;
  allOptions.forEach(function (el, ind) {
    if (el.checked) {
      selectedOptions.push(el.value);
    }
  });
  variantsData.variants.forEach(function (el, ind) {
    if (
      el.options.length == selectedOptions.length &&
      el.options.every((el) => selectedOptions.indexOf(el) != -1)
    ) {
      selectedOptionData = el;
    }
  });
  formInput.value = selectedOptionData.id;
  selectedOptionData.available
    ? ajaxButton.removeAttribute("disabled")
    : ajaxButton.setAttribute("disabled", "true");
}
function updateQuantityInput(el) {
  let input = el.closest("form").querySelector(".quantity");
  let currentValue = Number(input.value);
  if (el.classList.contains("quick-qn-plus")) {
    let updateValue = currentValue + 1;
    input.value = updateValue;
  } else if (el.classList.contains("quick-qn-minus")) {
    if (currentValue <= 1) return false;
    let updateValue = currentValue - 1;
    input.value = updateValue;
  }
}
document.addEventListener("click", function (e) {
  if (
    e.target.classList.contains("quick-qn-plus") ||
    e.target.closest(".quick-qn-plus")
  ) {
    console.log("plus clicked");
    e.preventDefault();
    let el = e.target.classList.contains("quick-qn-plus")
      ? e.target
      : e.target.closest(".quick-qn-plus");
    updateQuantityInput(el);
  } else if (
    e.target.classList.contains("quick-qn-minus") ||
    e.target.closest(".quick-qn-minus")
  ) {
    e.preventDefault();
    let el = e.target.classList.contains("quick-qn-minus")
      ? e.target
      : e.target.closest(".quick-qn-minus");
    updateQuantityInput(el);
  }
});
//////////////////////////rendering quick view
document.addEventListener("click", function (e) {
  if (
    e.target.classList.contains("quick-view-button") ||
    e.target.closest(".quick-view-button")
  ) {
    e.preventDefault();
    let el = e.target.classList.contains("quick-view-button")
      ? e.target
      : e.target.closest(".quick-view-button");
    let loader = el.closest("form").querySelector(".loader-wrapper");
    loader.classList.add("active");
    let url = el.dataset.product + "?view=quick-view";
    fetch(url)
      .then((response) => response.text())
      .then((data) => {
        let parser = new DOMParser();
        let html = parser.parseFromString(data, "text/html");
        let quickViewWrap = html.querySelector(".product-quick-view");
        document.querySelector(".quick-view-wrapper").innerHTML = "";
        document
          .querySelector(".quick-view-wrapper")
          .appendChild(quickViewWrap);
        loader.classList.remove("active");
        displayQuickView();

        new CardSlider({
          parent: ".product-quick-view-media .product-media-content",
          slidesToShow: 1,
          autoplay: true,
          arrows: true,
          dots: true,
          responsive: [
            {
              breakpoint: [991, "auto"],
              arrows: true,
              slidesToShow: 1,
              gap: 20,
              arrows: true,
              dots: false,
              time: 5000,
              autoplay: true,
            },
            {
              breakpoint: [481, 990],
              arrows: false,
              slidesToShow: 1,
              gap: 10,
              arrows: true,
              dots: true,
              time: 5000,
              autoplay: true,
            },
            {
              breakpoint: [0, 480],
              arrows: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              gap: 10,
              arrows: false,
              dots: true,
              time: 5000,
              autoplay: true,
            },
          ],
        }).slide();
      })
      .catch((error) => console.error(error));
  }
});
function displayQuickView() {
  let wrapper = document.querySelector(".quick-view-wrapper");
  let drop = document.querySelector(".quick-view-drop");
  wrapper.classList.toggle("active");
  drop.classList.toggle("active");
  wrapper.classList.contains("active")
    ? (document.querySelector("html").style.overflow = "hidden")
    : (document.querySelector("html").style.overflow = "auto");
}
document
  .querySelector(".quick-view-drop")
  .addEventListener("click", displayQuickView);
//////////////quantity update
document.addEventListener("click", function (e) {
  if (e.target.closest(".quick-view-wrapper")) {
    if (
      e.target.classList.contains("qn-plus") ||
      e.target.closest(".qn-plus ")
    ) {
      e.preventDefault();
      let el = e.target.classList.contains("qn-plus")
        ? e.target
        : e.target.closest(".qn-plus");
      updateValue(el, true);
    } else if (
      e.target.classList.contains("qn-minus") ||
      e.target.closest(".qn-minus ")
    ) {
      e.preventDefault();
      let el = e.target.classList.contains("qn-minus")
        ? e.target
        : e.target.closest(".qn-minus");
      updateValue(el, false);
    }
  }
});
function updateValue(el, plus) {
  let input = el.closest(".quantity-input").querySelector(".quantity");
  let currentValue = Number(input.value);
  let newValue;
  if (plus) {
    newValue = ++currentValue;
  } else {
    newValue = currentValue > 1 ? --currentValue : currentValue;
  }
  input.value = newValue;
}
document.addEventListener("click", (e) => {
  if (
    e.target.classList.contains("ajax-cart") ||
    e.target.closest(".ajax-cart")
  ) {
    let el = e.target.classList.contains("ajax-cart")
      ? e.target
      : e.target.closest(".ajax-cart");
    if (el.closest(".quick-view-form")) {
      displayQuickView();
    }
  }
});
